module.exports = __webpack_public_path__ + "static/Guilherme-Guerreiro-CV-99a0917e8f7c4254769c8f467eb91c52.pdf";